
function update_selected_variant(parent, refresh_cartjs){


  //first find out which variant we have to select
  var selected = ["","",""]
  $(parent).find(".product-options-cart .option-button.active").each(function(i,e){
    var this_option_value = $(this).attr("data-value")
    selected[i] = this_option_value
  })

  console.log("selected:")
  console.log(selected)

  var old_variant_id = parseInt($(parent).find(".product-select").find("option:selected").attr("data-id"))
  var old_select = $(parent).find(".product-select").find("option:selected")


  var props = `[data-option-1='${selected[0]}'][data-option-2='${selected[1]}'][data-option-3='${selected[2]}']`
  $(parent).find(".product-select").find(`option` + props).prop('selected', true)

  var selected_option = $(parent).find(".product-select").find("option:selected")

  var this_stock = selected_option.attr("data-stock")
  var this_variant = selected_option.attr("data-id")

  var this_policy = selected_option.attr("data-policy")
  var this_inv_manager = selected_option.attr("data-inv-man")
  var this_price = selected_option.attr("data-price")
  var this_sku = selected_option.attr("data-sku")



  // var old_variant_stock = $(parent).find(".product-select").find("option:selected").attr("data-stock")
  // var old_variant_policy = $(parent).find(".product-select").find("option:selected").attr("data-policy")
  if (this_stock <= 0 && this_policy == "deny" && this_inv_manager == "shopify"){

    $(parent).find(".product-select").find(`option` + props).prop('selected', false)
    old_select.prop('selected', true)
    var handle = $(parent).attr("data-handle")
    var variant_id = this_variant
    window.location = "/products/" + handle + "?variant=" + variant_id + "&notify=true"
    return false
  }

  var new_variant_id = parseInt(this_variant)
  var current_qty = parseInt($(parent).find(".qty-number").text())
  CartJS.removeItemById(old_variant_id);
  CartJS.addItem(new_variant_id, current_qty);


  return true


}


//dynamic line-item handling here
$(function(){


  //set UI state for variants/swatches
  $(".line-item").each(function(i,e){
    //create the initial state of inputs
    var this_select = $(e).find(".product-select")


    var option_1 = this_select.find("option:selected").attr("data-option-1")
    var option_2 = this_select.find("option:selected").attr("data-option-2")
    var option_3 = this_select.find("option:selected").attr("data-option-3")

    var options = [option_1,option_2,option_3]

    for (var option of options){
      if (option == "") continue
      var props = `[data-value='`+option+`']`
      $(e).find(".product-options-cart").find(`.option-button` + props).addClass('active')
    }


  })



})






//since this wasn't done will full-rivets support, we have to re-index the lines after one was removed
// (or refresh the whole window, which kinda sucks)
function re_index_items(){
  $(".line-item").each(function(i,e){
    $(e).attr("data-index", i)
  })
}

function pretty_price(price_cents){
  if (price_cents == 0) return 0
  if (!price_cents) return ""

  var price_dollars = price_cents / 100.0
  var decimal_part = price_dollars % 1

  if (decimal_part == 0)
    return price_dollars.toFixed(0)
  else
    return price_dollars.toFixed(2)
}


$(function(){


  $(document).on('cart.requestComplete', function(event, cart) {



    $(".cart-total").text("$" + pretty_price(cart.total_price) )

    $(".affirm-price").text("$" + pretty_price(cart.total_price / 4.0) )


    var i = 0;
    for( var item of cart.items){
      var line_item_html = $(".line-item[data-product-id='"+item.product_id+"']")
      if (line_item_html.length > 1){
        //this can happen if 1 line is discounted and others arent, but its the same product
        var line_item_html = $(".line-item[data-index='"+i+"']")
      }

      var line_price = pretty_price(item.final_line_price)

      if (item.line_level_total_discount > 0){
        var old_price = pretty_price(item.original_line_price)
        line_item_html.find(".total").html(`<strike>$${old_price}</strike> $${line_price}`)
      }
      else {
        line_item_html.find(".total").text("$" + line_price)
      }

      //make 100% sure the qty is adjusted and accurate
      $(line_item_html).find(".qty-number").text(item.quantity)
      i++;
    }


    var total_lines = $(".cart .line-item").length
    if (total_lines != cart.items.length){
      console.log("Total lines HTML:" + total_lines)
      console.log("Total lines Cart: " + cart.items.length)
      //they've done something which has inadventently added a line item... Best refresh the page to be safe

      location.reload();
    }

    else {
      $(".cart .line-item-list").removeClass("pending")
    }


  });


  //cart line-item button handlers
  $(".option-type .option-button").click(function(){
    //deselect previous choice... globally

    var parent = $(this).closest(".line-item")



    var this_option_name = $(this).closest(".option").attr("data-option")
    var this_option_value = $(this).attr("data-value")
    var option_container = $(parent).find(".option[data-option='"+this_option_name+"']")

    var old_button = option_container.find(".option-button.active")
    var old_value = option_container.find(".option-button.active").attr("data-value")
    option_container.find(".option-button.active").removeClass("active")

    //select this choice
    option_container.find(".option-button[data-value='"+this_option_value+"']").addClass("active")

    var is_updated = update_selected_variant(parent)

    if (!is_updated){
      //was OOS or whatever
      option_container.find(".option-button.active").removeClass("active")
      old_button.addClass("active")
    }
    else {
      $(".cart .line-item-list").addClass("pending")
    }



  })

  $(".qty-select .minus").click(function(){
    var current_number = parseInt($(this).closest(".qty-select").find(".qty-number").text())
    if (current_number == 1) return
    current_number--

    $(this).closest(".qty-select").find(".qty-number").text(current_number)

    var this_line = $(this).closest(".line-item")
    var variant_id = parseInt(this_line.find(".product-select").find("option:selected").attr("data-id"))
    var payload = {}
    payload[variant_id] = current_number

    $(".cart .line-item-list").addClass("pending")
    CartJS.updateItemQuantitiesById(payload, {
      success: function(){
        console.log("UPDATED QTY")
      }
    })

  })
  $(".qty-select .plus").click(function(){
    var current_number = parseInt($(this).closest(".qty-select").find(".qty-number").text())

    if (current_number >= 15) return
    current_number++
    $(this).closest(".qty-select").find(".qty-number").text(current_number)

    var this_line = $(this).closest(".line-item")
    var variant_id = parseInt(this_line.find(".product-select").find("option:selected").attr("data-id"))
    var payload = {}
    payload[variant_id] = current_number

    $(".cart .line-item-list").addClass("pending")
    CartJS.updateItemQuantitiesById(payload, {
      success: function(){
        console.log("UPDATED QTY")
      }
    })
  })


  $(".qty .remove-line").click(function(){
    var this_line = $(this).closest(".line-item")
    var variant_id = parseInt(this_line.find(".product-select").find("option:selected").attr("data-id"))
    this_line.slideUp(100).slideUp(100, function() { $(this).remove();re_index_items() } );

    //these are 1-indexed... dumb
    var this_line_number = parseInt($(this_line).attr("data-index")) + 1

    $(".cart .line-item-list").addClass("pending")
    CartJS.removeItem(this_line_number)
    //CartJS.removeItemById(variant_id);

    //we also need to recalc the index of each line
  })



  //upsell stuff
  $(".upsell-prod .quick-add").click(function(){

    var variant_id = $(this).attr('data-id')
    if (variant_id){
      $(this).html("Boom!")
      var var_id_int = parseInt(variant_id)
      CartJS.addItem(var_id_int, 1);
    }


  })








  $(".big-checkout").click(function(e){

    var is_pickup = $("#is-pickup").is(':checked')
    if (is_pickup){

      var pickup_date = $("#pickup-date").val()
      var pickup_time = $("#pickup-time").val()

      if (!pickup_date || !pickup_time){
        e.preventDefault()
        alert("Please select a pickup date and time")
        $("#pickup-date").addClass("error")
        $("#pickup-time").addClass("error")
        return;
      }
    }

    $(this).html("One Moment...")

  })





})


function add_business_days(days) {
  var now = new Date();
  var dayOfTheWeek = now.getDay();
  var calendarDays = days;
  var deliveryDay = dayOfTheWeek + days;
  if (deliveryDay >= 6) {
    //deduct this-week days
    days -= 6 - dayOfTheWeek;
    //count this coming weekend
    calendarDays += 2;
    //how many whole weeks?
    deliveryWeeks = Math.floor(days / 5);
    //two days per weekend per week
    calendarDays += deliveryWeeks * 2;
  }
  now.setTime(now.getTime() + calendarDays * 24 * 60 * 60 * 1000);
  return now;
}


function formatDate(date) {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2)
      month = '0' + month;
  if (day.length < 2)
      day = '0' + day;

  return [year, month, day].join('-');
}
